import { cityConstants } from '../constants';
import { cityService } from '../../services';

export const cityActions = {
  getCities,
  getProvinces
}

/*
ACTION: GET Cities BY PROVINCE ID
*/
function getCities(addToast, proviceID) {
  return dispatch => {
    dispatch(request());
    return cityService.getCities(proviceID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: cityConstants.GETALL_CITIES_REQUEST } }
  function success(items, total) { return { type: cityConstants.GETALL_CITIES_SUCCESS, items, total } }
  function failure(error) { return { type: cityConstants.GETALL_CITIES_FAILURE, error } }
}

/*
ACTION: GET Provinces
*/
function getProvinces(addToast) {
  return dispatch => {
    dispatch(request());
    return cityService.getProvinces()
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: cityConstants.GETALL_PROVINCES_REQUEST } }
  function success(items, total) { return { type: cityConstants.GETALL_PROVINCES_SUCCESS, items, total } }
  function failure(error) { return { type: cityConstants.GETALL_PROVINCES_FAILURE, error } }
}